import React from 'react';
import type { ThemeColours } from 'fym-shared/src/music24/releaseThemes';
import { TypedMemo } from '../../../../common/types';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the Profile; each part uses its own slice of it */
import styles from '../Profile.module.scss';
/* eslint-enable css-modules/no-unused-class */

/** The four colours of a look (design `.sw`): background, surface, text, accent. */
const ThemeSwatchesComponent: React.FC<{ colours: ThemeColours }> = ({ colours }) => (
  <span className={styles.swatches} aria-hidden="true">
    {[colours.background, colours.surface, colours.text, colours.accent].map((colour, index) => (
      // The four roles are fixed, so the index is a stable key.
      // eslint-disable-next-line react/no-array-index-key
      <i key={index} style={{ background: colour }} />
    ))}
  </span>
);

export const ThemeSwatches = TypedMemo(ThemeSwatchesComponent);
